module.exports = __webpack_public_path__ + "static/img/4.7b23948.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/7/1/6/zh/4.png
// module id = u7My
// module chunks = 0